
import { OnDemandAvailability as OnDemandConfig } from "@/utils/mealScheduling";
import { format } from "date-fns";
import { Clock, CalendarClock, Calendar } from "lucide-react";

interface OnDemandAvailabilityProps {
  config: OnDemandConfig;
}

const dayOrder = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export const OnDemandAvailability = ({ config }: OnDemandAvailabilityProps) => {
  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(':');
    return format(new Date().setHours(Number(hours), Number(minutes)), 'h:mm a');
  };

  const sortedDays = [...config.available_days].sort(
    (a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b)
  );

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-semibold mb-2">Availability Details</h4>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-start gap-2">
          <Clock className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
          <div>
            <p className="text-xs text-muted-foreground">Advanced Notice</p>
            <p className="text-sm">{config.prep_time_hours}h</p>
          </div>
        </div>
        
        <div className="flex items-start gap-2">
          <CalendarClock className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
          <div>
            <p className="text-xs text-muted-foreground">Daily Cutoff</p>
            <p className="text-sm">{formatTime(config.cutoff_time)}</p>
          </div>
        </div>
      </div>

      <div className="flex items-start gap-2">
        <Clock className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
        <div>
          <p className="text-xs text-muted-foreground">Pickup Window</p>
          <p className="text-sm">
            {formatTime(config.pickup_window_start)} - {formatTime(config.pickup_window_end)}
          </p>
        </div>
      </div>

      <div className="flex items-start gap-2">
        <Calendar className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
        <div>
          <p className="text-xs text-muted-foreground">Available Days</p>
          <div className="flex flex-wrap gap-1 mt-1">
            {sortedDays.map((day) => (
              <span
                key={day}
                className="inline-flex items-center rounded-md bg-secondary/50 px-2 py-0.5 text-xs font-medium text-secondary-foreground"
              >
                {day}
              </span>
            ))}
          </div>
        </div>
      </div>

      {config.max_daily_orders && (
        <p className="text-xs text-muted-foreground">
          Limited to {config.max_daily_orders} orders per day
        </p>
      )}
    </div>
  );
};
